

















































import Component from "vue-class-component";
import Vue from "vue";
//@ts-ignore
import store from '../../../store';
import {CurrentGame} from "../../../../types";
import KeyboardEventsObserver from "../../../services/KeyboardEventsObserver";
import {Tool} from "../../../helpers/Tool";
import EventApi from "../../../api/EventsApi";
import FieldAutomationsTable from "./FieldAutomationsTable.vue";
import {LayoutTypes} from "../../../../enums/layout-types/LayoutTypes";

@Component({
    components: {FieldAutomationsTable},
    props: {
        websocketUrl: {
            required: true,
            type: String,
        },
        uploadCardsUrl: {
            required: true,
            type: String,
        },
        uploadBackgroundUrl: {
            required: true,
            type: String,
        },
    }
})

/**
 * Редактирование игрового поля
 */
export default class EditField extends Vue {
    private readonly TYPE_INIT: string = 'init';
    private readonly TYPE_INIT_COMPLETE: string = 'initComplete';
    private readonly GET_FIELD: string = 'getField';
    private readonly FIELD_MESSAGE: string = 'fieldMessage';
    private readonly AUTOMATIONS_LIST: string = 'automationsList';
    private readonly TYPE_SAVE_FIELD_SUCCESS = 'saveFieldSuccess';
    private readonly TYPE_ACTIVITY_DATA = 'activityData';
    private readonly TYPE_DIFF = 'diff';
    private websocketUrl!: string;
    private connectionError: string|null = null;
    private connection: WebSocket|null = null;
    private isConnectedToServer: boolean = false;
    private gameContextMenuIsVisible: boolean = false;
    private contextMenuData: any = null;
    private keyboardEventsObserver: null|KeyboardEventsObserver = null;
    private adminId: string = '';
    private activity: CurrentGame|null = null;
    private automationsAreVisible: boolean = false;

    mounted(): void
    {
        this.adminId = Tool.getRandomNumber(1, 10000).toString();

        this.connectToServer();
        this.bindEvents();

        //показать контекстное меню стола-руки
        $(document).on('show_context_menu', (e) => {
            this.gameContextMenuIsVisible = true;
            this.contextMenuData = e.detail;
        });

        this.keyboardEventsObserver = new KeyboardEventsObserver();
    }

    beforeDestroy(): void
    {
        this.unbindEvents();
    }

    /**
     * Тип лейаута
     * @private
     */
    private get layoutType(): string
    {
        if (this.activity) {
            const type = this.activity.settings.layoutType;

            switch(type) {
                case 1:
                    return LayoutTypes.LAYOUT_DEFAULT;
                case 2:
                    return LayoutTypes.LAYOUT_TABLE;
                case 3:
                    return LayoutTypes.LAYOUT_TASK;
                case 4:
                    return LayoutTypes.LAYOUT_SEAT_ON_TABLE;
                default:
                    return LayoutTypes.LAYOUT_DEFAULT;
            }
        }

        return LayoutTypes.LAYOUT_DEFAULT;
    }

    /**
     * Соединение с websocket сервером
     */
    private connectToServer(): void
    {
        this.connectionError = null;
        this.connection = new WebSocket(this.websocketUrl);
        this.connection.onmessage = (e: MessageEvent) => this.onMessage(e);
        this.connection.onopen = () => this.onOpen();
        this.connection.onclose = () => {
            this.isConnectedToServer = false;
            // @ts-ignore
            this.connectionError = this.$t('modals.connection_problem');
        }
    }

    /**
     * Получение сообщения
     */
    private onMessage(e: MessageEvent): void
    {
        this.parseMessage(e.data);
    }

    /**
     * Открытие соединиения
     */
    private onOpen(): void
    {
        this.isConnectedToServer = true;
        this.sendMessage(this.TYPE_INIT, {})
    }

    /**
     * Отправка сообщения
     */
    private sendMessage(type: string, data: any)
    {
        //TODO: сделать получение id контент-пака как props
        const params = new URLSearchParams(window.location.search);
        data.contentPackId = params.has('id') ? params.get('id') : null;

        this.connection?.send(JSON.stringify({
            type: type,
            //TODO: изменить id админа
            adminId: this.adminId,
            data: data
        }));
    }

    /**
     * Отправка сообщения о добавлении автоматизации
     */
    private addAutomationMessage(e: any)
    {
        //TODO: сделать получение id контент-пака как props
        const params = new URLSearchParams(window.location.search);

        this.connection?.send(JSON.stringify({
            type: 'automation',
            data: {
                action: 'create',
                contentPackId: params.has('id') ? params.get('id') : null,
                data: e.detail
            }
        }));
    }

    /**
     * Отправка сообщения о добавлении автоматизации
     */
    private deleteAutomationMessage(e: any)
    {
        //TODO: сделать получение id контент-пака как props
        const params = new URLSearchParams(window.location.search);

        this.connection?.send(JSON.stringify({
            type: 'automation',
            data: {
                action: 'delete',
                contentPackId: params.has('id') ? params.get('id') : null,
                data: e.detail
            }
        }));
    }

    /**
     * Отправка сообщения о добавлении автоматизации
     */
    private updateAutomationMessage(e: any)
    {
        //TODO: сделать получение id контент-пака как props
        const params = new URLSearchParams(window.location.search);

        this.connection?.send(JSON.stringify({
            type: 'automation',
            data: {
                action: 'update',
                contentPackId: params.has('id') ? params.get('id') : null,
                data: e.detail
            }
        }));
    }

    /**
     * Обработка сообщения
     * @param rawMessage
     * @private
     */
    private parseMessage(rawMessage: string): void
    {
        const message = JSON.parse(rawMessage);
        const data = message.data;

        if (message.type === this.TYPE_INIT_COMPLETE) {
            this.sendMessage(this.GET_FIELD, {});
        }

        if (message.type === this.FIELD_MESSAGE) {
            store.dispatch('setGameField', data.field).then(() => {
                window.PixiScene?.gameFieldHandler(message.data.field);
            });
        }

        if (message.type === this.AUTOMATIONS_LIST) {
            store.dispatch('setAutomationsList', data.automations);
        }

        if (message.type === this.TYPE_DIFF) {
            window.PixiScene?.diffHandler(message.data);
        }

        if (message.type === this.TYPE_SAVE_FIELD_SUCCESS) {
            alert('Успешно сохранено');
        }

        if (message.type === this.TYPE_ACTIVITY_DATA) {
            this.activity = message.data.activity;
        }
    }

    /**
     * Текущее состояние стола-руки
     */
    private get currentGameField()
    {
        return store.getters.getGameField;
    }

    private bindEvents(): void
    {
        EventApi.addEventListener(EventApi.EVENT_SEND_MESSAGE, this.sendMessageFromEvent);
        EventApi.addEventListener(EventApi.SHOW_AUTOMATIONS, this.showAutomations);
        EventApi.addEventListener(EventApi.HIDE_AUTOMATIONS, this.hideAutomations);
        EventApi.addEventListener(EventApi.ADD_AUTOMATION, this.addAutomationMessage);
        EventApi.addEventListener(EventApi.DELETE_AUTOMATION, this.deleteAutomationMessage);
        EventApi.addEventListener(EventApi.UPDATE_AUTOMATION, this.updateAutomationMessage);
    }

    private unbindEvents(): void
    {
        EventApi.removeEventListener(EventApi.EVENT_SEND_MESSAGE, this.sendMessageFromEvent);
        EventApi.removeEventListener(EventApi.SHOW_AUTOMATIONS, this.showAutomations);
        EventApi.removeEventListener(EventApi.HIDE_AUTOMATIONS, this.hideAutomations);
        EventApi.removeEventListener(EventApi.ADD_AUTOMATION, this.addAutomationMessage);
        EventApi.removeEventListener(EventApi.DELETE_AUTOMATION, this.deleteAutomationMessage);
        EventApi.removeEventListener(EventApi.UPDATE_AUTOMATION, this.updateAutomationMessage);
    }

    /**
     * Отправить сообщение из события
     * @param e
     */
    private sendMessageFromEvent(e: any): void
    {
        this.sendMessage(e.detail.type, e.detail.data);
    }

    /**
     * Пререзагрузка страницы
     */
    private reload()
    {
        window.location.reload();
    }

    /**
     * Показать список автоматизаций
     * @private
     */
    private showAutomations(): void
    {
        this.automationsAreVisible = true;
    }

    /**
     * Скрыть список автоматизаций
     * @private
     */
    private hideAutomations(): void
    {
        this.automationsAreVisible = false;
    }
}
